export default "__VITE_ASSET__fQsSS19y__"